import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp, Star, CheckCircle2, XCircle, Settings, ShieldCheck, Zap, BookOpen, Clock, Users, Trophy } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59717683773521:1';
const AccordionItem = ({
  title,
  children,
  isOpen,
  onClick
}: {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}) => {
  return <div className="border border-zinc-800 rounded-lg mb-3 overflow-hidden bg-zinc-900/50" data-id="element-0">
      <button className="w-full px-4 sm:px-5 py-3.5 sm:py-4 flex justify-between items-center text-left hover:bg-zinc-800/50 transition-colors" onClick={onClick} data-id="element-1">
        <span className="font-semibold text-white text-sm sm:text-base pr-3 sm:pr-4" data-id="element-2">
          {title}
        </span>
        {isOpen ? <ChevronUp className="text-[#b4ff39] flex-shrink-0" size={20} data-id="element-3" /> : <ChevronDown className="text-zinc-400 flex-shrink-0" size={20} data-id="element-4" />}
      </button>
      <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] py-4 border-t border-zinc-800' : 'max-h-0 py-0'}`} data-id="element-5">
        <div className="text-zinc-300 space-y-2" data-id="element-6">{children}</div>
      </div>
    </div>;
};
const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  const names = ['Matias', 'Lucas', 'Facundo', 'Tomas', 'Agustin', 'Nicolas', 'Julian', 'Enzo', 'Franco', 'Gonzalo'];
  const cities = ['Córdoba', 'Rosario', 'Mendoza', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'CABA'];
  const times = ['hace 2 min', 'hace 5 min', 'hace 12 min', 'hace 1 min', 'hace 8 min'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = times[Math.floor(Math.random() * times.length)];
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(showPopup, 35000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-zinc-900 border border-zinc-700 rounded-lg p-4 shadow-2xl flex items-start gap-3 max-w-sm animate-in slide-in-from-bottom-5 fade-in duration-300" data-id="element-7">
      <div className="bg-[#b4ff39]/20 p-2 rounded-full mt-1" data-id="element-8">
        <CheckCircle2 className="text-[#b4ff39]" size={20} data-id="element-9" />
      </div>
      <div data-id="element-10">
        <p className="text-sm text-white font-medium" data-id="element-11">
          <span className="font-bold" data-id="element-12">{purchaseData.name}</span> de{' '}
          {purchaseData.city}
        </p>
        <p className="text-xs text-zinc-400 mt-1" data-id="element-13">
          Compró Arquero Imposible 360
        </p>
        <p className="text-[10px] text-zinc-500 mt-1" data-id="element-14">{purchaseData.time}</p>
      </div>
    </div>;
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  const totalSpots = 1000;
  const spotsLeft = 590;
  const percentage = spotsLeft / totalSpots * 100;
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-zinc-900 border border-red-900/50 rounded-xl p-4 sm:p-5 text-center relative overflow-hidden" data-id="element-15">
      <div className="absolute top-0 left-0 w-full h-1 bg-red-600" data-id="element-16"></div>

      <h3 className="text-red-500 font-bold text-sm sm:text-lg mb-4 flex items-center justify-center gap-2" data-id="element-17">
        <Clock size={18} data-id="element-18" />
        ¡OFERTA POR TIEMPO LIMITADO!
      </h3>

      <div className="flex justify-center items-start gap-2 sm:gap-4 mb-5" data-id="element-19">
        <div className="flex flex-col items-center" data-id="element-20">
          <div className="bg-black text-white text-2xl sm:text-3xl font-bold font-display w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center rounded-lg border border-zinc-800" data-id="element-21">
            {String(timeLeft.hours).padStart(2, '0')}
          </div>
          <span className="text-[10px] sm:text-xs text-zinc-400 mt-2 uppercase tracking-wider" data-id="element-22">
            Horas
          </span>
        </div>
        <div className="text-2xl sm:text-3xl font-bold text-zinc-600 mt-2 sm:mt-3" data-id="element-23">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-24">
          <div className="bg-black text-white text-2xl sm:text-3xl font-bold font-display w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center rounded-lg border border-zinc-800" data-id="element-25">
            {String(timeLeft.minutes).padStart(2, '0')}
          </div>
          <span className="text-[10px] sm:text-xs text-zinc-400 mt-2 uppercase tracking-wider" data-id="element-26">
            Min
          </span>
        </div>
        <div className="text-2xl sm:text-3xl font-bold text-zinc-600 mt-2 sm:mt-3" data-id="element-27">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-28">
          <div className="bg-black text-white text-2xl sm:text-3xl font-bold font-display w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center rounded-lg border border-zinc-800" data-id="element-29">
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
          <span className="text-[10px] sm:text-xs text-zinc-400 mt-2 uppercase tracking-wider" data-id="element-30">
            Seg
          </span>
        </div>
      </div>

      <div className="mt-4" data-id="element-31">
        <div className="flex justify-between text-xs sm:text-sm mb-2" data-id="element-32">
          <span className="text-zinc-400" data-id="element-33">Cupos disponibles</span>
          <span className="text-white font-bold" data-id="element-34">
            {spotsLeft} / {totalSpots}
          </span>
        </div>
        <div className="w-full bg-zinc-800 rounded-full h-3 overflow-hidden" data-id="element-35">
          <div className="bg-gradient-to-r from-red-600 to-red-500 h-full rounded-full relative" style={{
          width: `${percentage}%`
        }} data-id="element-36">
            <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-37"></div>
          </div>
        </div>
        <p className="text-xs text-red-400 mt-2" data-id="element-38">
          🔥 La demanda es alta. Asegurá tu lugar antes de que se agoten.
        </p>
      </div>
    </div>;
};
export function App() {
  const [openModule, setOpenModule] = useState<number | null>(0);
  const [openBonus, setOpenBonus] = useState<number | null>(0);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleModule = (index: number) => setOpenModule(openModule === index ? null : index);
  const toggleBonus = (index: number) => setOpenBonus(openBonus === index ? null : index);
  const toggleFaq = (index: number) => setOpenFaq(openFaq === index ? null : index);
  const handleCTA = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <div className="min-h-screen bg-[#050505] text-zinc-300 selection:bg-[#b4ff39] selection:text-black pb-20" data-id="element-39">
      <PurchasePopup data-id="element-40" />

      {/* HEADER / HERO */}
      <header className="pt-8 sm:pt-12 pb-8 px-4 max-w-4xl mx-auto text-center" data-id="element-41">
        <div className="inline-block bg-[#b4ff39]/10 border border-[#b4ff39]/20 text-[#b4ff39] px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold mb-5 uppercase tracking-wider" data-id="element-42">
          Atención Arqueros
        </div>
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-black text-white font-display leading-[1.05] mb-6 uppercase max-w-3xl mx-auto" data-id="element-43">
          Convertite en el arquero que tu equipo necesita{' '}
          <span className="text-[#b4ff39]" data-id="element-44">cuando el partido se complica</span>
        </h1>

        <div className="relative w-4/5 max-w-2xl mx-auto mb-6 rounded-2xl overflow-hidden border border-zinc-800 shadow-2xl shadow-[#b4ff39]/5" data-id="element-45">
          <button onClick={handleCTA} className="block w-full" aria-label="Ir a la compra" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/rdrDfpANJ2wfx2SUMLnb74/ChatGPT_Image_Jun_28,_2026,_03_29_59_PM.png" alt="Arquero Imposible 360 Bundle" className="w-full h-auto object-cover" data-id="element-47" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" data-id="element-48"></div>
          </button>
        </div>

        <p className="text-sm sm:text-base md:text-lg text-zinc-300 max-w-2xl mx-auto leading-snug mb-6" data-id="element-49">
          Todo lo que necesitás para dejar de improvisar bajo los tres palos y
          empezar a entrenar como un arquero moderno: técnica, táctica,
          preparación física, psicología deportiva y herramientas prácticas para
          mejorar tu rendimiento.
        </p>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8" data-id="element-50">
          <div className="flex items-center gap-2 bg-zinc-900 px-3 py-2 rounded-lg border border-zinc-800" data-id="element-51">
            <BookOpen className="text-[#b4ff39]" size={16} data-id="element-52" />
            <span className="font-medium text-white text-sm" data-id="element-53">100% Digital</span>
          </div>
          <div className="flex items-center gap-2 bg-zinc-900 px-3 py-2 rounded-lg border border-zinc-800" data-id="element-54">
            <Zap className="text-[#b4ff39]" size={16} data-id="element-55" />
            <span className="font-medium text-white text-sm" data-id="element-56">
              Entrega Inmediata
            </span>
          </div>
          <div className="flex items-center gap-2 bg-zinc-900 px-3 py-2 rounded-lg border border-zinc-800" data-id="element-57">
            <Trophy className="text-[#b4ff39]" size={16} data-id="element-58" />
            <span className="font-medium text-white text-sm" data-id="element-59">
              11 Módulos + 6 Bonos
            </span>
          </div>
        </div>

        <button onClick={handleCTA} className="w-full max-w-md mx-auto bg-[#b4ff39] hover:bg-[#9be000] text-black font-black text-lg sm:text-xl py-4 sm:py-5 px-6 sm:px-8 rounded-xl uppercase tracking-wide transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(180,255,57,0.3)] flex flex-col items-center justify-center gap-1" data-id="element-60">
          <span data-id="element-61">Quiero salvar el partido</span>
          <span className="text-xs font-semibold opacity-70" data-id="element-62">
            Acceso inmediato • Pago seguro
          </span>
        </button>
      </header>

      {/* PAIN POINTS */}
      <section className="py-12 sm:py-16 px-4 bg-red-950/20 border-y border-red-900/40" data-id="element-63">
        <div className="max-w-3xl mx-auto" data-id="element-64">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white text-center mb-8 sm:mb-10" data-id="element-65">
            Sabemos lo pesado de ser arquero y probablemente esto te suena
            familiar:
          </h2>

          <div className="space-y-3 sm:space-y-4" data-id="element-66">
            {['Te hacen goles que sabés que podrías haber evitado si hubieras estado mejor posicionado.', 'Dudás en las salidas aéreas y terminás quedándote a mitad de camino.', 'Un error en los primeros minutos te arruina la confianza para el resto del partido.', 'No sabés cómo entrenar por tu cuenta cuando no tenés entrenador de arqueros.', 'Te sentís lento de piernas o sin la potencia necesaria para llegar a pelotas difíciles.'].map((pain, i) => <div key={i} className="flex items-start gap-3 sm:gap-4 bg-red-950/40 p-4 sm:p-5 rounded-xl border border-red-700/50" data-id="element-67">
                <div className="bg-red-500/25 p-2 rounded-full mt-0.5 shrink-0" data-id="element-68">
                  <XCircle className="text-red-400" size={22} data-id="element-69" />
                </div>
                <p className="text-zinc-200 text-base sm:text-lg" data-id="element-70">{pain}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* PRODUCT INTRO & MODULES */}
      <section className="py-14 sm:py-20 px-4 max-w-3xl mx-auto" data-id="element-71">
        <div className="text-center mb-8 sm:mb-12" data-id="element-72">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white font-display uppercase mb-3" data-id="element-73">
            Para eso esta{' '}
            <span className="text-[#b4ff39]" data-id="element-74">Arquero Imposible 360</span>
          </h2>
          <p className="text-base sm:text-xl text-zinc-400" data-id="element-75">
            El sistema definitivo para dominar el arco moderno
          </p>
        </div>

        <div className="space-y-2" data-id="element-76">
          <AccordionItem title="🧤 TOMO 1 — Los Fundamentos del Arquero Moderno" isOpen={openModule === 0} onClick={() => toggleModule(0)} data-id="element-77">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-78">
              <li data-id="element-79">Posicionamiento</li>
              <li data-id="element-80">Técnica</li>
              <li data-id="element-81">Perfil corporal</li>
              <li data-id="element-82">Blocajes</li>
              <li data-id="element-83">Desvíos</li>
              <li data-id="element-84">Reducción de ángulos</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="👁️ TOMO 2 — Lectura del Juego y del Pateador" isOpen={openModule === 1} onClick={() => toggleModule(1)} data-id="element-85">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-86">
              <li data-id="element-87">Lenguaje corporal</li>
              <li data-id="element-88">Lectura del rival</li>
              <li data-id="element-89">Anticipación</li>
              <li data-id="element-90">Tipos de remate</li>
              <li data-id="element-91">Decisiones</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="⚡ TOMO 3 — Mano a Mano y Situaciones Reales" isOpen={openModule === 2} onClick={() => toggleModule(2)} data-id="element-92">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-93">
              <li data-id="element-94">Achiques</li>
              <li data-id="element-95">Rebotes</li>
              <li data-id="element-96">Balones divididos</li>
              <li data-id="element-97">Uno contra uno</li>
              <li data-id="element-98">Resolución bajo presión</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="✈️ TOMO 4 — Juego Aéreo y Dominio del Área" isOpen={openModule === 3} onClick={() => toggleModule(3)} data-id="element-99">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-100">
              <li data-id="element-101">Centros</li>
              <li data-id="element-102">Salidas</li>
              <li data-id="element-103">Timing</li>
              <li data-id="element-104">Contacto</li>
              <li data-id="element-105">Pelotas paradas</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="💪 TOMO 5 — Preparación Física Específica" isOpen={openModule === 4} onClick={() => toggleModule(4)} data-id="element-106">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-107">
              <li data-id="element-108">Fuerza</li>
              <li data-id="element-109">Potencia</li>
              <li data-id="element-110">Velocidad</li>
              <li data-id="element-111">Agilidad</li>
              <li data-id="element-112">Prevención</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="🧠 TOMO 6 — Preparación Mental del Arquero" isOpen={openModule === 5} onClick={() => toggleModule(5)} data-id="element-113">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-114">
              <li data-id="element-115">Confianza</li>
              <li data-id="element-116">Concentración</li>
              <li data-id="element-117">Manejo del error</li>
              <li data-id="element-118">Liderazgo</li>
              <li data-id="element-119">Rutinas</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="📅 TOMO 7 — Planificación del Entrenamiento" isOpen={openModule === 6} onClick={() => toggleModule(6)} data-id="element-120">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-121">
              <li data-id="element-122">Cómo entrenar</li>
              <li data-id="element-123">Planes semanales</li>
              <li data-id="element-124">Materiales</li>
              <li data-id="element-125">Evaluaciones</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="📊 TOMO 8 — El Arquero Inteligente" isOpen={openModule === 7} onClick={() => toggleModule(7)} data-id="element-126">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-127">
              <li data-id="element-128">Análisis de partidos</li>
              <li data-id="element-129">Estadísticas</li>
              <li data-id="element-130">Corrección de errores</li>
              <li data-id="element-131">Preparación táctica</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="🏆 TOMO DIBU — Psicología Deportiva para Arqueros" isOpen={openModule === 8} onClick={() => toggleModule(8)} data-id="element-132">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-133">
              <li data-id="element-134">Mentalidad del arquero</li>
              <li data-id="element-135">Construcción de confianza</li>
              <li data-id="element-136">Miedo a equivocarse</li>
              <li data-id="element-137">Gestión emocional</li>
              <li data-id="element-138">Concentración</li>
              <li data-id="element-139">Penales</li>
              <li data-id="element-140">Visualización</li>
              <li data-id="element-141">Liderazgo</li>
              <li data-id="element-142">Rutinas mentales</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="🏋️ TOMO 10 — Entrenamiento de Fuerza para Arqueros" isOpen={openModule === 9} onClick={() => toggleModule(9)} data-id="element-143">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-144">
              <li data-id="element-145">Fuerza específica</li>
              <li data-id="element-146">Potencia</li>
              <li data-id="element-147">Pliometría</li>
              <li data-id="element-148">Core</li>
              <li data-id="element-149">Tren superior</li>
              <li data-id="element-150">Explosividad</li>
              <li data-id="element-151">Movilidad</li>
              <li data-id="element-152">Prevención</li>
              <li data-id="element-153">Programación anual</li>
              <li data-id="element-154">Test físicos</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="📐 TOMO 11 — Biomecánica del Arquero Moderno" isOpen={openModule === 10} onClick={() => toggleModule(10)} data-id="element-155">
            <ul className="list-disc pl-5 space-y-1 text-zinc-400" data-id="element-156">
              <li data-id="element-157">Biomecánica de la posición base</li>
              <li data-id="element-158">Cómo impulsarse correctamente</li>
              <li data-id="element-159">Biomecánica de las caídas</li>
              <li data-id="element-160">Saltos laterales</li>
              <li data-id="element-161">Salidas altas</li>
              <li data-id="element-162">Blocajes</li>
              <li data-id="element-163">Atajadas con una mano</li>
              <li data-id="element-164">Atajadas a ras del suelo</li>
              <li data-id="element-165">Cómo ganar velocidad sin correr más</li>
              <li data-id="element-166">Errores biomecánicos que hacen perder décimas de segundo</li>
              <li data-id="element-167">Prevención de lesiones desde la técnica</li>
            </ul>
          </AccordionItem>
        </div>

        <div className="mt-12 text-center" data-id="element-168">
          <button onClick={handleCTA} className="bg-[#b4ff39] hover:bg-[#9be000] text-black font-bold py-4 px-8 rounded-xl uppercase tracking-wide transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(180,255,57,0.2)]" data-id="element-169">
            Acceder a todos los tomos ahora
          </button>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-12 sm:py-16 px-4 bg-zinc-900/50 border-y border-zinc-800/50" data-id="element-170">
        <div className="max-w-5xl mx-auto" data-id="element-171">
          <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-8 sm:mb-12" data-id="element-172">
            Lo que dicen los arqueros que ya están entrenando
          </h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-173">
            {[{
            name: 'Federico, 22 años',
            text: 'Me cambió la cabeza. El tomo de psicología y el de lectura de juego me hicieron dar cuenta de errores que cometía todos los findes. Ahora atajo mucho más tranquilo.',
            role: 'Liga Amateur, Buenos Aires'
          }, {
            name: 'Martín, 19 años',
            text: 'No tengo entrenador de arqueros en mi club y esto me salvó. Las rutinas y la biomecánica me ayudaron a mejorar el salto y las caídas sin lastimarme.',
            role: 'Reserva, Santa Fe'
          }, {
            name: 'Alejandro, 28 años',
            text: 'Juego torneos relámpago y siempre me costaban los mano a mano. Apliqué lo del Tomo 3 y achico mucho mejor los espacios. Vale cada peso.',
            role: 'Fútbol 7, Córdoba'
          }, {
            name: 'Ignacio, 25 años',
            text: 'El manual de penales y el análisis de pateadores es una locura. Ya atajé 3 penales en el torneo aplicando los tips de lectura corporal. Recomendadísimo.',
            role: 'Torneo Comercial, Mendoza'
          }].map((test, i) => <div key={i} className="bg-zinc-900 p-6 rounded-xl border border-zinc-800 flex flex-col h-full" data-id="element-174">
                <div className="flex gap-1 mb-4" data-id="element-175">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} size={16} className="fill-[#b4ff39] text-[#b4ff39]" data-id="element-176" />)}
                </div>
                <p className="text-zinc-300 italic mb-6 flex-grow" data-id="element-177">
                  "{test.text}"
                </p>
                <div data-id="element-178">
                  <p className="font-bold text-white" data-id="element-179">{test.name}</p>
                  <p className="text-xs text-zinc-500" data-id="element-180">{test.role}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* COMPARISON TABLE */}
      <section className="py-12 sm:py-16 px-4 bg-zinc-900/30 border-y border-zinc-800/50" data-id="element-181">
        <div className="max-w-4xl mx-auto" data-id="element-182">
          <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-8 sm:mb-10" data-id="element-183">
            La diferencia es clara
          </h2>

          <div className="grid grid-cols-2 gap-0 rounded-xl overflow-hidden border border-zinc-800" data-id="element-184">
            {/* SIN */}
            <div className="bg-zinc-900/80 p-3 sm:p-6 md:p-8" data-id="element-185">
              <h3 className="text-red-500 font-bold text-center text-sm sm:text-lg md:text-xl mb-4 sm:mb-6 pb-3 sm:pb-4 border-b border-zinc-800" data-id="element-186">
                Sin Arquero Imposible 360
              </h3>
              <ul className="space-y-3 sm:space-y-4" data-id="element-187">
                {['Entrenás sin un plan claro', 'Dudás en las salidas y centros', 'Te frustrás rápido tras un error', 'Dependés solo de tus reflejos', 'No sabés analizar a los rivales'].map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3 text-xs sm:text-base text-zinc-400" data-id="element-188">
                    <XCircle className="text-red-500/70 shrink-0 mt-0.5" size={16} data-id="element-189" />
                    <span data-id="element-190">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* CON */}
            <div className="bg-[#b4ff39]/5 p-3 sm:p-6 md:p-8 border-l border-zinc-800 relative" data-id="element-191">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#b4ff39]" data-id="element-192"></div>
              <h3 className="text-[#b4ff39] font-bold text-center text-sm sm:text-lg md:text-xl mb-4 sm:mb-6 pb-3 sm:pb-4 border-b border-zinc-800/50" data-id="element-193">
                Con Arquero Imposible 360
              </h3>
              <ul className="space-y-3 sm:space-y-4" data-id="element-194">
                {['Planificación profesional', 'Dominio total del área', 'Mentalidad de acero (Tomo Dibu)', 'Técnica y biomecánica pulida', 'Lectura anticipada del juego'].map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3 text-xs sm:text-base text-white font-medium" data-id="element-195">
                    <CheckCircle2 className="text-[#b4ff39] shrink-0 mt-0.5" size={16} data-id="element-196" />
                    <span data-id="element-197">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-14 sm:py-20 px-4 max-w-3xl mx-auto" data-id="element-198">
        <div className="text-center mb-8 sm:mb-12" data-id="element-199">
          <div className="inline-flex items-center justify-center bg-yellow-500/10 border border-yellow-500/30 text-yellow-500 px-4 py-2 rounded-full text-xs sm:text-sm font-bold uppercase tracking-wider mb-5" data-id="element-200">
            🎁 Solo por hoy: GRATIS
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white font-display uppercase mb-3" data-id="element-201">
            Queremos que seas imposible de descontar
          </h2>
          <p className="text-base sm:text-xl text-zinc-400" data-id="element-202">
            Así que preparamos estos bonos exclusivos que te llevás GRATIS hoy.
          </p>
        </div>

        <div className="space-y-3" data-id="element-203">
          <AccordionItem title="🎁 Bono 1 — ArqueroGPT" isOpen={openBonus === 0} onClick={() => toggleBonus(0)} data-id="element-204">
            <p className="text-zinc-400" data-id="element-205">
              Más de 100 prompts para convertir cualquier IA en tu entrenador
              personal. Creá rutinas, analizá situaciones y pedí consejos
              tácticos específicos para tu nivel.
            </p>
          </AccordionItem>

          <AccordionItem title="🎁 Bono 2 — Manual de Penales" isOpen={openBonus === 1} onClick={() => toggleBonus(1)} data-id="element-206">
            <p className="text-zinc-400" data-id="element-207">
              Técnicas avanzadas de distracción, lectura de la carrera del
              pateador, biomecánica del salto en penales y estadísticas de hacia
              dónde patean según el perfil.
            </p>
          </AccordionItem>

          <AccordionItem title="🎁 Bono 3 — Manual de Análisis de Pateadores" isOpen={openBonus === 2} onClick={() => toggleBonus(2)} data-id="element-208">
            <p className="text-zinc-400" data-id="element-209">
              Cómo perfilar a los delanteros rivales, entender sus tendencias y
              anticipar sus decisiones antes de que toquen la pelota.
            </p>
          </AccordionItem>

          <AccordionItem title="🎁 Bono 4 — Dominá el Juego con los Pies" isOpen={openBonus === 3} onClick={() => toggleBonus(3)} data-id="element-210">
            <p className="text-zinc-400" data-id="element-211">
              Ejercicios y conceptos para ser el primer atacante de tu equipo.
              Pases filtrados, controles orientados bajo presión y toma de
              decisiones en salida.
            </p>
          </AccordionItem>

          <AccordionItem title="🎁 Bono 5 — Diario del Arquero PRO" isOpen={openBonus === 4} onClick={() => toggleBonus(4)} data-id="element-212">
            <p className="text-zinc-400" data-id="element-213">
              (PDF + Google Sheets). Plantillas profesionales para trackear tu
              rendimiento, goles recibidos, atajadas clave, estado físico y
              evolución mental partido a partido.
            </p>
          </AccordionItem>

          <AccordionItem title="🎁 Bono 6 — Manual del Arquero Profesional y Pelota Parada" isOpen={openBonus === 5} onClick={() => toggleBonus(5)} data-id="element-214">
            <p className="text-zinc-400" data-id="element-215">
              Armado de barreras perfecto, posicionamiento en córners a favor y
              en contra, y cómo organizar a tu defensa como un líder absoluto.
            </p>
          </AccordionItem>
        </div>
      </section>

      {/* FINAL OFFER */}
      <section className="py-14 sm:py-20 px-4 max-w-2xl mx-auto" id="checkout" data-id="element-216">
        <div className="bg-zinc-900 border-2 border-[#b4ff39]/30 rounded-2xl p-1 shadow-[0_0_50px_rgba(180,255,57,0.12)]" data-id="element-217">
          <div className="bg-[#0a0a0a] rounded-xl overflow-hidden" data-id="element-218">
            {/* Urgency header */}
            <div className="p-4 sm:p-6 border-b border-zinc-800" data-id="element-219">
              <CountdownTimer data-id="element-220" />
            </div>

            <div className="p-5 sm:p-8" data-id="element-221">
              {/* Title */}
              <div className="text-center mb-6" data-id="element-222">
                <h2 className="text-2xl sm:text-3xl font-black text-white font-display uppercase mb-1" data-id="element-223">
                  Resumen de tu pedido
                </h2>
                <p className="text-sm text-zinc-400" data-id="element-224">
                  Acceso de por vida a todo el material
                </p>
              </div>

              {/* Order summary card */}
              <div className="bg-zinc-900/70 rounded-xl border border-zinc-800 divide-y divide-zinc-800 mb-5" data-id="element-225">
                <div className="flex justify-between items-center gap-3 p-4" data-id="element-226">
                  <div className="flex items-center gap-3 min-w-0" data-id="element-227">
                    <BookOpen className="text-zinc-400 shrink-0" size={18} data-id="element-228" />
                    <span className="text-white font-medium text-sm sm:text-base truncate" data-id="element-229">
                      Arquero Imposible 360 (11 Tomos)
                    </span>
                  </div>
                  <span className="text-zinc-500 line-through text-sm shrink-0" data-id="element-230">
                    $45.000
                  </span>
                </div>

                <div className="flex justify-between items-center gap-3 p-4" data-id="element-231">
                  <div className="flex items-center gap-3 min-w-0" data-id="element-232">
                    <Zap className="text-yellow-500 shrink-0" size={18} data-id="element-233" />
                    <span className="text-white font-medium text-sm sm:text-base truncate" data-id="element-234">
                      6 Bonos Exclusivos
                    </span>
                  </div>
                  <span className="text-yellow-500 font-bold text-sm shrink-0" data-id="element-235">
                    GRATIS
                  </span>
                </div>

                <div className="flex justify-between items-center gap-3 p-4 bg-zinc-900/40" data-id="element-236">
                  <span className="text-white font-bold text-sm sm:text-base" data-id="element-237">
                    Valor total real
                  </span>
                  <span className="text-red-500 line-through font-bold text-base sm:text-lg shrink-0" data-id="element-238">
                    $88.990
                  </span>
                </div>
              </div>

              {/* Price block */}
              <div className="relative text-center mb-6 bg-[#b4ff39]/10 py-6 px-4 rounded-xl border border-[#b4ff39]/30" data-id="element-239">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#b4ff39] text-black text-xs font-black uppercase tracking-wide px-3 py-1 rounded-full whitespace-nowrap" data-id="element-240">
                  Ahorrás 73% solo hoy
                </div>
                <p className="text-zinc-300 mt-2 mb-2 uppercase tracking-wide text-xs font-bold" data-id="element-241">
                  Precio especial por hoy
                </p>
                <div className="flex items-end justify-center gap-1.5" data-id="element-242">
                  <span className="text-xl sm:text-2xl text-zinc-400 font-bold mb-1" data-id="element-243">
                    AR$
                  </span>
                  <span className="text-5xl sm:text-6xl font-black text-[#b4ff39] font-display leading-none" data-id="element-244">
                    24.199
                  </span>
                </div>
                <p className="text-xs text-zinc-500 mt-3" data-id="element-245">
                  Pago único. Sin suscripciones.
                </p>
              </div>

              {/* CTA */}
              <button onClick={handleCTA} className="w-full bg-[#b4ff39] hover:bg-[#9be000] text-black font-black text-lg sm:text-2xl py-5 sm:py-6 px-6 rounded-xl uppercase tracking-wide transition-all transform hover:scale-[1.02] shadow-[0_0_40px_rgba(180,255,57,0.4)] flex flex-col items-center justify-center gap-1.5" data-id="element-246">
                <span data-id="element-247">Quiero salvar el partido</span>
                <span className="text-xs sm:text-sm font-bold opacity-70 flex items-center gap-2" data-id="element-248">
                  <ShieldCheck size={16} data-id="element-249" /> Compra 100% Segura
                </span>
              </button>

              {/* Trust badges */}
              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-zinc-500 text-xs sm:text-sm" data-id="element-250">
                <div className="flex items-center gap-1.5" data-id="element-251">
                  <CheckCircle2 size={14} className="text-[#b4ff39]" data-id="element-252" /> Acceso
                  inmediato
                </div>
                <div className="flex items-center gap-1.5" data-id="element-253">
                  <CheckCircle2 size={14} className="text-[#b4ff39]" data-id="element-254" /> 100%
                  Digital
                </div>
                <div className="flex items-center gap-1.5" data-id="element-255">
                  <CheckCircle2 size={14} className="text-[#b4ff39]" data-id="element-256" /> Pago
                  seguro
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ / OBJECTIONS */}
      <section className="py-12 sm:py-16 px-4 max-w-3xl mx-auto" data-id="element-257">
        <h2 className="text-xl sm:text-2xl font-bold text-white text-center mb-8 sm:mb-10" data-id="element-258">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-259">
          <AccordionItem title="¿Es un libro físico o digital?" isOpen={openFaq === 0} onClick={() => toggleFaq(0)} data-id="element-260">
            <p className="text-zinc-400" data-id="element-261">
              Es 100% digital (formato PDF). Esto te permite tenerlo en tu
              celular, tablet o computadora y llevarlo a los entrenamientos.
              Además, al ser digital, te lo enviamos inmediatamente después de
              la compra.
            </p>
          </AccordionItem>

          <AccordionItem title="¿Sirve si juego fútbol amateur o torneos con amigos?" isOpen={openFaq === 1} onClick={() => toggleFaq(1)} data-id="element-262">
            <p className="text-zinc-400" data-id="element-263">
              Totalmente. Los conceptos de posicionamiento, lectura de juego y
              técnica aplican para cualquier nivel. De hecho, si no tenés
              entrenador de arqueros, este material te va a dar una ventaja
              enorme sobre el resto.
            </p>
          </AccordionItem>

          <AccordionItem title="¿Cómo recibo el material?" isOpen={openFaq === 2} onClick={() => toggleFaq(2)} data-id="element-264">
            <p className="text-zinc-400" data-id="element-265">
              Una vez aprobado el pago, recibirás automáticamente un correo
              electrónico con el link para descargar todos los tomos y los
              bonos. ¡En menos de 2 minutos podés empezar a leer!
            </p>
          </AccordionItem>

          <AccordionItem title="¿Cuáles son los métodos de pago?" isOpen={openFaq === 3} onClick={() => toggleFaq(3)} data-id="element-266">
            <p className="text-zinc-400" data-id="element-267">
              Aceptamos MercadoPago, tarjetas de crédito, débito y
              transferencias. Todo procesado de forma 100% segura.
            </p>
          </AccordionItem>
        </div>
      </section>

      {/* FOOTER / SUPPORT */}
      <footer className="py-10 text-center border-t border-zinc-800/50 mt-10" data-id="element-268">
        <div className="flex flex-col items-center justify-center gap-3 mb-6" data-id="element-269">
          <div className="bg-zinc-900 p-3 rounded-full border border-zinc-800" data-id="element-270">
            <Settings className="text-zinc-400" size={24} data-id="element-271" />
          </div>
          <p className="text-zinc-400 text-sm" data-id="element-272">
            ¿Tenés dudas o problemas con tu compra? Contactá a soporte:
          </p>
          <a href="mailto:EbookDreamShop@gmail.com" className="text-white font-bold hover:text-[#b4ff39] transition-colors" data-id="element-273">
            EbookDreamShop@gmail.com
          </a>
        </div>
        <p className="text-xs text-zinc-600" data-id="element-274">
          Este sitio no forma parte del sitio web de Facebook ni de Facebook
          Inc.
          <br data-id="element-275" />
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}